<script setup lang="ts">
import {defineProps, ref} from "vue"
defineProps<{ source: string }>()
const audio = ref<HTMLAudioElement>()
</script>

<template>
  <div class="voiceover-button">
    <audio ref="audio" :src="source" preload="auto" style="display: none;"/>
    <a href="#" @click.prevent="audio.play()">
      <img src="/svg/icons/speaker.svg" class="speaker-icon" alt="Play Voiceover">
    </a>
  </div>
</template>

<style scoped lang="scss">
  .speaker-icon {
    width: 3rem;
  }
</style>
